import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { FlexColumn, FlexRow, FlexRowBetween } from 'components'
import { FileUploadPicker } from 'components/FileUploadPicker'
import { AppPrimaryButton, RTEFormWithoutControllerField } from 'elements'
import { Accordion, AccordionTitle, Card, Checkbox, Input, Radio, TextArea } from 'semantic-ui-react'
import { AcceptFileType, ChartRadioStatus, DateFormat, DateUtility } from 'utility'

export const CompanyHeader = () => {
    return <div>Header</div>
}

export const AboutUs = ({ item, submitAnswer }) => {
    return <>
        <TextArea
            onChange={(val) => submitAnswer({ Answer: val, UniqueId: item.UniqueId || item.ComponentType, ComponentType: item.ComponentType })}
            label="About us"
        />
    </>
}

export const FileUpload = ({ item, submitAnswer }) => {
    const [files, setFiles] = useState([])
    const onSubmit = (list) => {
        setFiles(list)
        submitAnswer({ Files: list.map(ele => ele.file.file), ComponentType: item.ComponentType, UniqueId: item.UniqueId || item.ComponentType })
    }
    return <div className="h-20">
        <FileUploadPicker
            maxFiles={5}
            maxFileSize={500}
            accept={AcceptFileType.all}
            addedNewFiles={onSubmit}
            files={files}
        />
    </div>
}

export const SectionBox = ({ section, selectSection }) => {
    const [open, setOpen] = useState(true)
    return (
        <Accordion fluid styled className="mt-4">
            <AccordionTitle
                index={section.SectionId}
                className=""
            >
                <FlexRowBetween>
                    <FlexRow className="align-items-center">
                        <Checkbox className="me-3" checked={section.IsSelected} onChange={() => selectSection(section.SectionId, !section.IsSelected)} />
                        <span onClick={() => setOpen(!open)}>{section.SectionName} - {section.SubsectionName}</span>
                    </FlexRow>
                    <FlexRow>
                        <FlexRowBetween>
                            <Radio
                                name={section.SectionId}
                                className="mx-3"
                                checked={section.ChartOption === ChartRadioStatus.None}
                                defaultChecked
                                onChange={() => selectSection(section.SectionId, true, ChartRadioStatus.None)}
                            /><label>None</label>
                            <Radio
                                name={section.SectionId}
                                checked={section.ChartOption === ChartRadioStatus.Pie}
                                className="mx-3"
                                onChange={() => selectSection(section.SectionId, true, ChartRadioStatus.Pie)}
                            /><label>Pie Chart</label>
                            <Radio
                                name={section.SectionId}
                                checked={section.ChartOption === ChartRadioStatus.Bar}
                                className="mx-3"
                                onChange={() => selectSection(section.SectionId, true, ChartRadioStatus.Bar)}
                            /><label>Bar Chart</label>
                        </FlexRowBetween>
                    </FlexRow>
                </FlexRowBetween>
            </AccordionTitle>
        </Accordion>)
}

export const TextAreaWithEditor = ({ submitAnswer, item }) => {
    return <RTEFormWithoutControllerField
        value={item.Answers?.[0]?.Answer}
        onChange={(val) => submitAnswer({ Answer: val, UniqueId: item.UniqueId || item.ComponentType, ComponentType: item.ComponentType })}
    />
}

export const SectionResult = ({ item, templateData, submitAnswer }) => {
    const [sections, setSections] = useState(templateData.Sections || [])
    const [all, setAll] = useState(false)
    useEffect(() => {
        setSections(sections?.map(ele => ({
            ...ele,
            IsSelected: Boolean(item?.Answers?.[0]?.TemplateSectionId?.find((item) => item.SectionId === ele.SectionId)),
            ChartOption: ele.ChartOption || 0,
        })))
    }, [item])

    const selectSection = (id, status, chart) => {
        const updatedList = sections.map(ele => ({
            ...ele,
            IsSelected: id === ele.SectionId ? status : ele.IsSelected,
            ChartOption: id === ele.SectionId ? chart : ele.ChartOption,
        }))
        setSections(updatedList)
        submitAnswer({
            ComponentType: item.ComponentType,
            TemplateSectionId: updatedList.filter(ele => ele.IsSelected),
            UniqueId: item.UniqueId || item.ComponentType,
        })
    }

    const selectAll = () => {
        const updatedList = sections.map(ele => ({
            ...ele,
            IsSelected: !all,
        }))
        setSections(updatedList)
        submitAnswer({
            ComponentType: item.ComponentType,
            TemplateSectionId: updatedList.filter(ele => ele.IsSelected),
            UniqueId: item.UniqueId || item.ComponentType,
        })
        setAll(!all)
    }

    return <>
        <FlexRow className="pointer" onClick={selectAll}>
            <Checkbox checked={all || sections.every(ele => ele.IsSelected)} />
            <span className="ms-2">Select All</span></FlexRow>
        {sections.map(section => <div key={section.SectionId}>
            <SectionBox section={section} selectSection={selectSection} />
        </div>)}
    </>
}

export const TextboxWithBulletPoint = ({ item, submitAnswer }) => {
    const [fields, setfields] = useState([{ text: "", UniqueId: 0 }])

    useEffect(() => {
        if (item?.Answers && item?.Answers?.length) {
            setfields(item?.Answers?.map(ele => ({ ...ele, text: ele.Answer })))
        }
    }, [item])

    const onChange = (data, text) => {
        setfields(fields.map(ele => ({
            ...ele,
            text: ele.UniqueId === data.UniqueId ? text : ele.text,
        })))
        submitAnswer({
            ComponentType: item.ComponentType,
            UniqueId: item.UniqueId || data.UniqueId,
            Answer: text,
        })
    }
    const onAdd = () => {
        setfields([...fields, { UniqueId: fields.length, text: "" }])
        submitAnswer({
            ComponentType: item.ComponentType,
            UniqueId: item.UniqueId || fields.length,
            Answer: "",
            New: true,
        })
    }
    return (<div>
        <div className="d-flex justify-content-end mb-3">
            <AppPrimaryButton
                onClick={onAdd}>Create +
            </AppPrimaryButton>
        </div>
        <FlexRow className="flex-wrap">
            {fields.map((ele) => {
                return (<div className="col-12 ps-3 mb-3" key={`${ele.SubsectionID} bullet`}>
                    <Input
                        className="col-12"
                        value={ele.text}
                        onChange={(e) => onChange(ele, e.target.value)}
                    />
                </div>)
            })}
        </FlexRow>
    </div>
    )
}
const HeaderFormContainer = styled.div`
.card {
    width: 100%;
}
`
export const TextBoxWithHeader = ({ item, submitAnswer }) => {
    const [fields, setfields] = useState([{ Header: "", Answer: "", UniqueId: 0 }])

    const onChange = (data, name, text) => {
        const list = fields.map(ele => ({
            ...ele,
            [name]: ele.UniqueId === data.UniqueId ? text : ele.text,
        }))
        setfields(list)
        submitAnswer({
            ComponentType: item.ComponentType,
            UniqueId: item.UniqueId || data.UniqueId,
            [name]: text,
        })
    }

    useEffect(() => {
        if (item?.Answers && item?.Answers?.length) {
            setfields(item?.Answers?.map(ele => ({ ...ele })))
        }
    }, [item])

    const onAdd = () => {
        setfields([...fields, { UniqueId: fields.length, text: "" }])
        submitAnswer({
            ComponentType: item.ComponentType,
            UniqueId: item.UniqueId || fields.length,
            Answer: "",
            Header: "",
            New: true,
        })
    }
    return (<HeaderFormContainer>
        <div className="d-flex justify-content-end mb-3">
            <AppPrimaryButton
                onClick={onAdd}>Create +
            </AppPrimaryButton>
        </div>
        <FlexRow className="flex-wrap d-flex">
            {fields.map((ele, i) => {
                return (
                    <div className="col-12 p-2" key={`header-desc${i}`}>
                        <Card className="mb-3 d-flex" key={`${ele.UniqueId} header`}>
                            <Card.Content className="w-100">
                                <FlexColumn className="mb-3">
                                    <label>Header</label>
                                    <Input
                                        value={ele.Header}
                                        onChange={(e) => onChange(ele, "Header", e.target.value)}
                                    />
                                </FlexColumn>
                                <FlexColumn>
                                    <label>Description</label>
                                    <TextArea
                                        value={ele.Answer}
                                        onChange={(e) => onChange(ele, "Answer", e.target.value)}
                                    />
                                </FlexColumn>
                            </Card.Content>
                        </Card>
                    </div>
                )
            })}
        </FlexRow>
    </HeaderFormContainer>
    )
}

export const LocationDetail = ({ location }) => {
    return (<div>
        <FlexRow className="row">
            <div className="col-2">LocationName</div>
            <div className="col-9">: {location.LocationName || "-"}</div>
        </FlexRow>
        <FlexRow className="row">
            <div className="col-2">CustomerPhone</div>
            <div className="col-9">: {location.CustomerPhone || "-"}</div>
        </FlexRow>
        <FlexRow className="row">
            <div className="col-2">CustomerEmail</div>
            <div className="col-9">: {location.CustomerEmail || "-"}</div>
        </FlexRow>
        <FlexRow className="row">
            <div className="col-2">CustomerFullAddress</div>
            <div className="col-9">: {location.CustomerFullAddress || "-"}</div>
        </FlexRow>
    </div>)
}

export const CustomerDetail = ({ customer }) => {
    return (<div>
        <FlexRow className="row">
            <div className="col-2">AuditName</div>
            <div className="col-9">: {customer.AuditName || "-"}</div>
        </FlexRow>
        <FlexRow className="row">
            <div className="col-2">Created By</div>
            <div className="col-9">: {customer.CreatedByName || "-"}</div>
        </FlexRow>
        <FlexRow className="row">
            <div className="col-2">Created On</div>
            <div className="col-9">: {DateUtility.dateToLocalISO(new Date(customer.CreatedOn), DateFormat.dateTime)}</div>
        </FlexRow>
        <FlexRow className="row">
            <div className="col-2">Updated On</div>
            <div className="col-9">: {DateUtility.dateToLocalISO(new Date(customer.UpdatedOn), DateFormat.dateTime)}</div>
        </FlexRow>
    </div>)
}